import { CustomMap } from '@vendor/libs/maps/maps';
import MapUtils from '@vendor/js/map-utils';
import { Api } from '@vendor/js/api';
import Common from '@vendor/js/common';
import EntityType from '@vendor/js/enums/EntityType';
const _ApiariesMineCommonHandler = (function () {
    const setupDeleteApplyModalHandler = (submitUrl) => {
        Common.handleModalForm('apiary_delete_apply', {
            submitUrl,
        });
    };
    return {
        // Public functions
        init: function () {
            const form = $('[name="entity_id"]').closest('form');
            const map = CustomMap.getMap('map');
            if (!map) {
                return;
            }
            const features = map.getFeatures('apiaries');
            if (!features) {
                return;
            }
            features.on('add', async function ({ feature }) {
                // find the association by this feature
                const geojson = MapUtils.featureToGeojson(feature);
                try {
                    const response = await Api.get(`/map/entities?type=${EntityType.ASSOCIATION.value}&geojson=${JSON.stringify(geojson)}`);
                    if (response.data.entities.length) {
                        $('[name="entity_id"]')
                            .val(response.data.entities[0].id)
                            .trigger('change');
                        Common.fillFormElement(form, 'entity_id', response.data.entities[0].id);
                    }
                }
                catch (err) {
                    if (err instanceof Error) {
                        console.error('Could not get entity by geojson: ' + err.message);
                    }
                }
            });
        },
        setupDeleteApplyModalHandler,
    };
})();
window.ApiariesMineCommonHandler = _ApiariesMineCommonHandler;
